<p *ngIf="!isLoading && (!shops || shops.length === 0) && isImpersonationMode">
  {{ 'NO_MANAGED_SHOPS' | translate }}
</p>

<div class="row shop-list" *ngIf="shops">
  <a
    [id]="'selectShop_' + shop._id"
    class="col-12 col-sm-6"
    [class.success]="isRecommended(shop)"
    (click)="editShop(shop)"
    *ngFor="let shop of shops"
  >
    <div class="shop-list-item">
      <lh-manage-shop-item
        [shop]="shop"
        (viewBookings)="viewShopBookings(shop)"
        (viewTransactions)="viewShopTransactions(shop)"
        (viewTaxSettings)="viewTaxSettings(shop)"
        (viewInStoreDisplay)="viewInShopDisplay(shop)"
        (viewPricing)="viewShopPricing(shop)"
        (viewSettings)="editShop(shop)"
      ></lh-manage-shop-item>
    </div>
  </a>
</div>

<div class="form-group" *ngIf="isShopOwner">
  <button
    id="addShop"
    class="btn"
    [class.btn-primary]="!shops?.length"
    [class.btn-default]="shops?.length"
    (click)="addShop()"
  >
    {{ 'ADD_STORAGE_LOCATION' | translate }}
  </button>
  <button class="btn btn-link" (click)="addDummyShop()" *ngIf="isDebugMode">Skip</button>
</div>
